<!-- eslint-disable vue/no-unused-vars -->
<template>
    <div class="date-range-picker">
        <VueDateRangePicker
            ref="picker"
            :opens="openPosition"
            :locale-data="localOptions"
            :ranges="defaultRanges"
            :time-picker="false"
            :single-date-picker="singleDatePicker"
            :time-picker-24-hour="true"
            :show-dropdowns="true"
            :auto-apply="true"
            :min-date="dateLimitProp.minDate"
            :max-date="dateLimitProp.maxDate"
            :dateRange="dateRange"
            v-model="dateRange"
            @update="update"
        >
            <template v-slot:input="{ startDate = dateRange.startDate, endDate = dateRange.endDate }">
                <div class="show-date-range">
                    <i class="bi bi-calendar-week dp__input_icon dp__input_icons" style="margin-top: 12px; margin-left: 15px; font-size: 16px"></i>
                    <span v-if="singleDay">{{ formatDate(startDate) }}</span>
                    <span v-else>{{ formattedStartDate }} - {{ formattedEndDate }}</span>
                </div>
            </template>
        </VueDateRangePicker>
    </div>
</template>

<script>
import VueDateRangePicker from 'vue3-daterange-picker'
import moment from 'moment'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: 'DateRangePicker',
    components: { VueDateRangePicker },
    props: {
        callback: Function,
        dateName: String,
        hideIcon: Boolean,
        singleDatePicker: Boolean,
        dateLimit: Object,
        dateData: Object,
        openPosition: String,
        showDateFormat: String,
        autoApply: Boolean,
        defaultRange: String,
        language: {
            type: String,
            default: 'tr',
        },
    },
    data() {
        return {
            defaultRangeDay: 15,
            dateLimitProp: {
                minDate: '2018-01-01',
                maxDate: '2022-01-01',
            },
            dateRange: {
                startDate: '2021-01-01',
                endDate: '2021-01-07',
            },
            localOptions: {
                direction: 'ltr',
                format: 'MM/DD/YYYY',
                separator: ' - ',
                applyLabel: 'Uygula',
                cancelLabel: 'İptal',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: '',
                monthNames: '',
                firstDay: 1,
            },
            defaultRanges: {},
        }
    },
    computed: {
        singleDay() {
            return moment(this.dateRange.endDate).isSame(this.dateRange.startDate, 'day')
        },
        formattedStartDate() {
            return moment(this.dateRange.startDate).format(this.showDateFormat || 'DD MMM YYYY')
        },
        formattedEndDate() {
            return moment(this.dateRange.endDate).format(this.showDateFormat || 'DD MMM YYYY')
        },
    },
    methods: {
        formatDate(date) {
            return moment(date).format(this.showDateFormat || 'DD MMM YYYY')
        },
        rangeDefault() {
            const today = moment().startOf('day').toDate()
            let startDate = moment()
                .subtract(this.defaultRangeDay - 1, 'days')
                .toDate()
            let endDate = today

            if (this.singleDatePicker) {
                if (this.dateData) {
                    this.dateRange.startDate = moment(this.dateData.startDate).toDate()
                    this.dateRange.endDate = moment(this.dateData.startDate).toDate()
                } else {
                    this.dateRange.startDate = endDate
                    this.dateRange.endDate = endDate
                }
            } else {
                if (this.dateData) {
                    this.dateRange.startDate = moment(this.dateData.startDate).toDate()
                    this.dateRange.endDate = moment(this.dateData.endDate).toDate()
                } else {
                    this.dateRange.startDate = startDate
                    this.dateRange.endDate = endDate
                }
            }

            if (this.dateLimit) {
                this.dateLimitProp.minDate = this.dateLimit.minDate
                this.dateLimitProp.maxDate = this.dateLimit.maxDate
            } else {
                this.dateLimitProp.maxDate = today
            }
        },

        rangeListGenerator() {
            const today = moment().startOf('day').toDate()

            this.defaultRanges[this.$t('common.date.today')] = [today, today]
            this.defaultRanges[this.$t('common.date.lastSevenDays')] = [moment().subtract(6, 'days').toDate(), today]
            this.defaultRanges[this.$t('common.date.lastFifteenDays')] = [moment().subtract(14, 'days').toDate(), today]
            this.defaultRanges[this.$t('common.date.lastThirtyDays')] = [moment().subtract(29, 'days').toDate(), today]
            this.defaultRanges[this.$t('common.date.lastNinetyDays')] = [moment().subtract(89, 'days').toDate(), today]
            this.defaultRanges[this.$t('common.date.last180days')] = [moment().subtract(179, 'days').toDate(), today]
            this.defaultRanges[this.$t('common.date.thisYear')] = [new Date(new Date().getFullYear(), 0, 1), today]
            if (this.defaultRange !== 'removeAllTime') {
                this.defaultRanges[this.$t('common.date.allTime')] = [moment('2018-01-01').toDate(), today]
            } else {
                const minDate = moment(this.dateLimitProp.minDate).add(1, 'day').toDate()
                this.defaultRanges[this.$t('common.date.allTime')] = [minDate, today]
            }
        },
        update() {
            if (this.callback) {
                this.callback(this.dateRange, this.dateName)
            }
        },
        handleDate() {
            this.defaultRanges = {}
            moment.locale(this.language)
            if (this.language === 'tr') {
                this.localOptions.daysOfWeek = ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt']
                this.localOptions.monthNames = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara']
            }
            if (this.language === 'en') {
                this.localOptions.daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                this.localOptions.monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                this.localOptions.firstDay = 0
            }

            this.rangeDefault()
            this.rangeListGenerator()
            this.update()
        },
    },
    watch: {
        dateRange: {
            handler() {
                this.callback(this.dateRange, this.dateName)
            },
            deep: true,
        },
        dateData: {
            handler() {
                this.handleDate()
            },
            deep: true,
        },
        language: {
            handler() {
                this.handleDate()
            },
            immediate: true,
        },
    },
}
</script>

<style scoped></style>
